import PropTypes from 'prop-types';

const WrapRootElement = ({ children }) => children;

WrapRootElement.propTypes = {
  children: PropTypes.node,
};

export default WrapRootElement;
